<button *ngIf="!disabled" type="button" [class]="buttonClass" (click)="onClick($event)" [title]="text"
  [attr.aria-disabled]="this.disabled ? 'true' : 'false'" [placement]="placement" [ngbPopover]="text">
  <span [class]="iconClass" aria-hidden="true"></span>
</button>